import {IPulseType} from '@shared/models/entities';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl
} from '@angular/forms';
import {BaseFormComponent} from '@shared/base.form-component';
import {AddressDTO} from '@staff-app/models/termStaffContactInfoDTO';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'idp2-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent extends BaseFormComponent implements OnInit {
  addressForm: FormGroup;

  @Input()
  userAddress: AddressDTO;
  @Input()
  countries: IPulseType[];
  @Input()
  usStates: any[];
  @Input()
  canadaProvinces: any[];
  @Input()
  set isParentSubmitted(val: boolean) {
    this.submitted = val;
  }
  @Output()
  formReady = new EventEmitter<FormGroup>();
  cityPlaceHolder = 'City';
  postalPlaceHolder = 'Zip Code';
  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.addressForm = this.fb.group({
      country: [Enums.CountryType.USA, [Validators.required]],
      addressLine1: [null, [Validators.required]],
      addressLine2: [null],
      city: [null, [Validators.required]],
      state: [null, [Validators.required]],
      postalCode: [null, [Validators.required]]
    });
    this.onChanges();
    this.loadData();

    this.myForm = this.addressForm;
    this.formReady.emit(this.addressForm);
  }
  private onChanges(): void {
    this.addressForm.get('country').valueChanges.subscribe(val => {
      if (this.isUS() || this.isCanada()) {
        this.cityPlaceHolder = 'City';
        if (this.isUS()) {
          this.postalPlaceHolder = 'Zip code';
        } else {
          this.postalPlaceHolder = 'Postal code';
        }
        this.setValidators(this.addressForm.get('state') as FormControl, [
          Validators.required,
          Validators.maxLength(10)
        ]);
        this.setValidators(this.addressForm.get('postalCode') as FormControl, [
          Validators.required,
          Validators.maxLength(10)
        ]);
      } else {
        this.postalPlaceHolder = 'Postal code';
        this.cityPlaceHolder = 'City/Territory';
        this.clearValidators(this.addressForm.get('postalCode') as FormControl);
        this.clearValidators(this.addressForm.get('state') as FormControl);
      }
      this.addressForm.get('state').setValue(null);
      this.addressForm.updateValueAndValidity();
    });
  }
  private loadData() {
    if (this.userAddress && this.submitted === false) {
      const state = this.userAddress.stateTypeID
        ? this.userAddress.stateTypeID
        : this.userAddress.state;

      this.addressForm.patchValue({
        country:
          this.userAddress.countryTypeID > 0
            ? this.userAddress.countryTypeID
            : null,
        addressLine1: this.userAddress.addressLine1,
        addressLine2: this.userAddress.addressLine2,
        city: this.userAddress.city,
        state: state,
        postalCode: this.userAddress.postalCode
      });
      this.addressForm.updateValueAndValidity();
      this.formReady.emit(this.addressForm);
    }
  }
  isUS() {
    return (
      this.addressForm.get('country') &&
      this.addressForm.get('country').value === Enums.CountryType.USA
    );
  }
  isCanada() {
    return (
      this.addressForm.get('country') &&
      this.addressForm.get('country').value === Enums.CountryType.Canada
    );
  }
}
